import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const unlockOperationsRoute: InvariantJiraRoute = {
	name: 'eoc-unlock-operations',
	path: '/jira/settings/products/ops/unlock',
	exact: true,
};
